import Vue from "vue";
export default Vue.extend({
    props: {
        items: [],
    },
    data() {
        return {
            selection: null,
        };
    },
    methods: {
        onRemoveTariffConnection(tariffId) {
            this.$emit("drop", tariffId);
        },
    },
});
